export const RWA_SHARED_ERC1155_ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "name_",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "symbol_",
        "type": "string"
      },
      {
        "internalType": "address[]",
        "name": "initialMinters",
        "type": "address[]"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "ApprovalForAll",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "MinterUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "indexed": false,
        "internalType": "uint256[]",
        "name": "values",
        "type": "uint256[]"
      }
    ],
    "name": "TransferBatch",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "TransferSingle",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "accounts",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      }
    ],
    "name": "balanceOfBatch",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "burn",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "isApprovedForAll",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "minters",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "safeBatchTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "setApprovalForAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "setMinter",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

export const RWA_SHARED_ERC1155_BYTECODE = "0x60806040523480156200001157600080fd5b5060405162001676380380620016768339810160408190526200003491620001fe565b600280546001600160a01b031916331790556000620000548482620003a4565b506001620000638382620003a4565b5060005b81518110156200011e57600082828151811062000088576200008862000470565b6020026020010151905060006001600160a01b0316816001600160a01b03161462000108576001600160a01b038116600081815260056020908152604091829020805460ff1916600190811790915591519182527fb21afb9ce9be0a676f8f317ff0ca072fb89a4f8ce2d1b6fe80f8755c14f1cb19910160405180910390a25b5080620001158162000486565b91505062000067565b50505050620004ae565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f191681016001600160401b038111828210171562000169576200016962000128565b604052919050565b600082601f8301126200018357600080fd5b81516001600160401b038111156200019f576200019f62000128565b6020620001b5601f8301601f191682016200013e565b8281528582848701011115620001ca57600080fd5b60005b83811015620001ea578581018301518282018401528201620001cd565b506000928101909101919091529392505050565b6000806000606084860312156200021457600080fd5b83516001600160401b03808211156200022c57600080fd5b6200023a8783880162000171565b94506020915081860151818111156200025257600080fd5b620002608882890162000171565b9450506040860151818111156200027657600080fd5b8601601f810188136200028857600080fd5b8051828111156200029d576200029d62000128565b8060051b9250620002b08484016200013e565b818152928201840192848101908a851115620002cb57600080fd5b928501925b848410156200030557835192506001600160a01b0383168314620002f45760008081fd5b8282529285019290850190620002d0565b8096505050505050509250925092565b600181811c908216806200032a57607f821691505b6020821081036200034b57634e487b7160e01b600052602260045260246000fd5b50919050565b601f8211156200039f57600081815260208120601f850160051c810160208610156200037a5750805b601f850160051c820191505b818110156200039b5782815560010162000386565b5050505b505050565b81516001600160401b03811115620003c057620003c062000128565b620003d881620003d1845462000315565b8462000351565b602080601f831160018114620004105760008415620003f75750858301515b600019600386901b1c1916600185901b1785556200039b565b600085815260208120601f198616915b82811015620004415788860151825594840194600190910190840162000420565b5085821015620004605787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b634e487b7160e01b600052603260045260246000fd5b600060018201620004a757634e487b7160e01b600052601160045260246000fd5b5060010190565b6111b880620004be6000396000f3fe608060405234801561001057600080fd5b50600436106100e95760003560e01c806395d89b411161008c578063e985e9c511610066578063e985e9c5146101ed578063f242432a14610200578063f46eccc414610213578063f5298aca1461023657600080fd5b806395d89b41146101bf578063a22cb465146101c7578063cf456ae7146101da57600080fd5b80632eb2c2d6116100c85780632eb2c2d61461014c5780634e1273f414610161578063731133e9146101815780638da5cb5b1461019457600080fd5b8062fdd58e146100ee57806301ffc9a71461011457806306fdde0314610137575b600080fd5b6101016100fc366004610c03565b610249565b6040519081526020015b60405180910390f35b610127610122366004610c2d565b6102c0565b604051901515815260200161010b565b61013f6102f3565b60405161010b9190610c5e565b61015f61015a366004610d3a565b610381565b005b61017461016f366004610df5565b6105bd565b60405161010b9190610e61565b61015f61018f366004610ea5565b6106ca565b6002546101a7906001600160a01b031681565b6040516001600160a01b03909116815260200161010b565b61013f6107d8565b61015f6101d5366004610f0d565b6107e5565b61015f6101e8366004610f0d565b610851565b6101276101fb366004610f49565b61093b565b61015f61020e366004610f7c565b610969565b610127610221366004610ff4565b60056020526000908152604090205460ff1681565b61015f61024436600461100f565b610aea565b60006001600160a01b0383166102955760405162461bcd60e51b815260206004820152600c60248201526b5a65726f206164647265737360a01b60448201526064015b60405180910390fd5b5060008181526003602090815260408083206001600160a01b03861684529091529020545b92915050565b60006301ffc9a760e01b6001600160e01b0319831614806102ba5750506001600160e01b031916636cdb3d1360e11b1490565b6000805461030090611042565b80601f016020809104026020016040519081016040528092919081815260200182805461032c90611042565b80156103795780601f1061034e57610100808354040283529160200191610379565b820191906000526020600020905b81548152906001019060200180831161035c57829003601f168201915b505050505081565b6001600160a01b0387166103a75760405162461bcd60e51b815260040161028c9061107c565b6001600160a01b0387163b156103ea5760405162461bcd60e51b8152602060048201526008602482015267454f41206f6e6c7960c01b604482015260640161028c565b6001600160a01b0388163314806104065750610406883361093b565b6104415760405162461bcd60e51b815260206004820152600c60248201526b139bdd08185c1c1c9bdd995960a21b604482015260640161028c565b8483146104795760405162461bcd60e51b8152602060048201526006602482015265098cadccee8d60d31b604482015260640161028c565b60005b858110156105575760008787838181106104985761049861109d565b90506020020135905060008686848181106104b5576104b561109d565b905060200201359050806003600084815260200190815260200160002060008d6001600160a01b03166001600160a01b03168152602001908152602001600020600082825461050491906110c9565b909155505060008281526003602090815260408083206001600160a01b038e1684529091528120805483929061053b9084906110dc565b925050819055505050808061054f906110ef565b91505061047c565b50866001600160a01b0316886001600160a01b0316336001600160a01b03167f4a39dc06d4c0dbc64b70af90fd698a233a518aa5d07e595d983b8c0526c8f7fb898989896040516105ab949392919061113a565b60405180910390a45050505050505050565b60608382146105f75760405162461bcd60e51b8152602060048201526006602482015265098cadccee8d60d31b604482015260640161028c565b60008467ffffffffffffffff8111156106125761061261116c565b60405190808252806020026020018201604052801561063b578160200160208202803683370190505b50905060005b858110156106c05761069187878381811061065e5761065e61109d565b90506020020160208101906106739190610ff4565b8686848181106106855761068561109d565b90506020020135610249565b8282815181106106a3576106a361109d565b6020908102919091010152806106b8816110ef565b915050610641565b5095945050505050565b6002546001600160a01b03163314806106f257503360009081526005602052604090205460ff165b61072b5760405162461bcd60e51b815260206004820152600a6024820152692737ba1036b4b73a32b960b11b604482015260640161028c565b6001600160a01b0385166107515760405162461bcd60e51b815260040161028c9061107c565b60008481526003602090815260408083206001600160a01b0389168452909152812080548592906107839084906110dc565b909155505060408051858152602081018590526001600160a01b0387169160009133917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a45050505050565b6001805461030090611042565b3360008181526004602090815260408083206001600160a01b03871680855290835292819020805460ff191686151590811790915590519081529192917f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a35050565b6002546001600160a01b031633146108985760405162461bcd60e51b815260206004820152600a60248201526927b7363c9037bbb732b960b11b604482015260640161028c565b6001600160a01b0382166108dc5760405162461bcd60e51b815260206004820152600b60248201526a2d32b9379036b4b73a32b960a91b604482015260640161028c565b6001600160a01b038216600081815260056020908152604091829020805460ff191685151590811790915591519182527fb21afb9ce9be0a676f8f317ff0ca072fb89a4f8ce2d1b6fe80f8755c14f1cb19910160405180910390a25050565b6001600160a01b03918216600090815260046020908152604080832093909416825291909152205460ff1690565b6001600160a01b03851661098f5760405162461bcd60e51b815260040161028c9061107c565b6001600160a01b0385163b156109d25760405162461bcd60e51b8152602060048201526008602482015267454f41206f6e6c7960c01b604482015260640161028c565b6001600160a01b0386163314806109ee57506109ee863361093b565b610a295760405162461bcd60e51b815260206004820152600c60248201526b139bdd08185c1c1c9bdd995960a21b604482015260640161028c565b60008481526003602090815260408083206001600160a01b038a16845290915281208054859290610a5b9084906110c9565b909155505060008481526003602090815260408083206001600160a01b038916845290915281208054859290610a929084906110dc565b909155505060408051858152602081018590526001600160a01b03808816929089169133917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a4505050505050565b6002546001600160a01b0316331480610b1257503360009081526005602052604090205460ff165b80610b2557506001600160a01b03831633145b610b625760405162461bcd60e51b815260206004820152600e60248201526d139bdd08185d5d1a1bdc9a5e995960921b604482015260640161028c565b60008281526003602090815260408083206001600160a01b038716845290915281208054839290610b949084906110c9565b909155505060408051838152602081018390526000916001600160a01b0386169133917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a4505050565b80356001600160a01b0381168114610bfe57600080fd5b919050565b60008060408385031215610c1657600080fd5b610c1f83610be7565b946020939093013593505050565b600060208284031215610c3f57600080fd5b81356001600160e01b031981168114610c5757600080fd5b9392505050565b600060208083528351808285015260005b81811015610c8b57858101830151858201604001528201610c6f565b506000604082860101526040601f19601f8301168501019250505092915050565b60008083601f840112610cbe57600080fd5b50813567ffffffffffffffff811115610cd657600080fd5b6020830191508360208260051b8501011115610cf157600080fd5b9250929050565b60008083601f840112610d0a57600080fd5b50813567ffffffffffffffff811115610d2257600080fd5b602083019150836020828501011115610cf157600080fd5b60008060008060008060008060a0898b031215610d5657600080fd5b610d5f89610be7565b9750610d6d60208a01610be7565b9650604089013567ffffffffffffffff80821115610d8a57600080fd5b610d968c838d01610cac565b909850965060608b0135915080821115610daf57600080fd5b610dbb8c838d01610cac565b909650945060808b0135915080821115610dd457600080fd5b50610de18b828c01610cf8565b999c989b5096995094979396929594505050565b60008060008060408587031215610e0b57600080fd5b843567ffffffffffffffff80821115610e2357600080fd5b610e2f88838901610cac565b90965094506020870135915080821115610e4857600080fd5b50610e5587828801610cac565b95989497509550505050565b6020808252825182820181905260009190848201906040850190845b81811015610e9957835183529284019291840191600101610e7d565b50909695505050505050565b600080600080600060808688031215610ebd57600080fd5b610ec686610be7565b94506020860135935060408601359250606086013567ffffffffffffffff811115610ef057600080fd5b610efc88828901610cf8565b969995985093965092949392505050565b60008060408385031215610f2057600080fd5b610f2983610be7565b915060208301358015158114610f3e57600080fd5b809150509250929050565b60008060408385031215610f5c57600080fd5b610f6583610be7565b9150610f7360208401610be7565b90509250929050565b60008060008060008060a08789031215610f9557600080fd5b610f9e87610be7565b9550610fac60208801610be7565b94506040870135935060608701359250608087013567ffffffffffffffff811115610fd657600080fd5b610fe289828a01610cf8565b979a9699509497509295939492505050565b60006020828403121561100657600080fd5b610c5782610be7565b60008060006060848603121561102457600080fd5b61102d84610be7565b95602085013595506040909401359392505050565b600181811c9082168061105657607f821691505b60208210810361107657634e487b7160e01b600052602260045260246000fd5b50919050565b6020808252600790820152665a65726f20746f60c81b604082015260600190565b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052601160045260246000fd5b818103818111156102ba576102ba6110b3565b808201808211156102ba576102ba6110b3565b600060018201611101576111016110b3565b5060010190565b81835260006001600160fb1b0383111561112157600080fd5b8260051b80836020870137939093016020019392505050565b60408152600061114e604083018688611108565b8281036020840152611161818587611108565b979650505050505050565b634e487b7160e01b600052604160045260246000fdfea26469706673582212205b580a893dc2b5c272dcc5be9c0cc02df678aeae7f1f37adefc0e63fe35d0e5064736f6c63430008130033";

export const RWA_SHARED_ERC1155_SOLIDITY_SOURCE = "// SPDX-License-Identifier: MIT\npragma solidity ^0.8.19;\n\n/**\n * @title RwaSharedErc1155\n * @notice Minimal multi-token catalog: per (id, holder) balances, owner + `minters` for\n *         `mint` and `burn`. Includes basic `safeTransferFrom` / batch transfer for EOA recipients\n *         (no ERC1155Receiver callback — not full IERC1155 safety; extend with OpenZeppelin for production).\n */\ncontract RwaSharedErc1155 {\n    string public name;\n    string public symbol;\n    address public owner;\n\n    mapping(uint256 => mapping(address => uint256)) private _balances;\n    mapping(address => mapping(address => bool)) private _operatorApprovals;\n    mapping(address => bool) public minters;\n\n    event TransferSingle(\n        address indexed operator,\n        address indexed from,\n        address indexed to,\n        uint256 id,\n        uint256 value\n    );\n    event TransferBatch(\n        address indexed operator,\n        address indexed from,\n        address indexed to,\n        uint256[] ids,\n        uint256[] values\n    );\n    event ApprovalForAll(address indexed account, address indexed operator, bool approved);\n    event MinterUpdated(address indexed account, bool allowed);\n\n    modifier onlyOwner() {\n        require(msg.sender == owner, \"Only owner\");\n        _;\n    }\n\n    constructor(string memory name_, string memory symbol_, address[] memory initialMinters) {\n        owner = msg.sender;\n        name = name_;\n        symbol = symbol_;\n        for (uint256 i = 0; i < initialMinters.length; i++) {\n            address a = initialMinters[i];\n            if (a != address(0)) {\n                minters[a] = true;\n                emit MinterUpdated(a, true);\n            }\n        }\n    }\n\n    function setMinter(address account, bool allowed) external onlyOwner {\n        require(account != address(0), \"Zero minter\");\n        minters[account] = allowed;\n        emit MinterUpdated(account, allowed);\n    }\n\n    function supportsInterface(bytes4 interfaceId) external pure returns (bool) {\n        return interfaceId == 0x01ffc9a7 || interfaceId == 0xd9b67a26;\n    }\n\n    function balanceOf(address account, uint256 id) public view returns (uint256) {\n        require(account != address(0), \"Zero address\");\n        return _balances[id][account];\n    }\n\n    function balanceOfBatch(\n        address[] calldata accounts,\n        uint256[] calldata ids\n    ) external view returns (uint256[] memory) {\n        require(accounts.length == ids.length, \"Length\");\n        uint256[] memory batch = new uint256[](accounts.length);\n        for (uint256 i = 0; i < accounts.length; i++) {\n            batch[i] = balanceOf(accounts[i], ids[i]);\n        }\n        return batch;\n    }\n\n    function setApprovalForAll(address operator, bool approved) external {\n        _operatorApprovals[msg.sender][operator] = approved;\n        emit ApprovalForAll(msg.sender, operator, approved);\n    }\n\n    function isApprovedForAll(address account, address operator) public view returns (bool) {\n        return _operatorApprovals[account][operator];\n    }\n\n    function safeTransferFrom(\n        address from,\n        address to,\n        uint256 id,\n        uint256 amount,\n        bytes calldata /* data */\n    ) external {\n        require(to != address(0), \"Zero to\");\n        require(to.code.length == 0, \"EOA only\");\n        require(from == msg.sender || isApprovedForAll(from, msg.sender), \"Not approved\");\n        _balances[id][from] -= amount;\n        _balances[id][to] += amount;\n        emit TransferSingle(msg.sender, from, to, id, amount);\n    }\n\n    function safeBatchTransferFrom(\n        address from,\n        address to,\n        uint256[] calldata ids,\n        uint256[] calldata amounts,\n        bytes calldata /* data */\n    ) external {\n        require(to != address(0), \"Zero to\");\n        require(to.code.length == 0, \"EOA only\");\n        require(from == msg.sender || isApprovedForAll(from, msg.sender), \"Not approved\");\n        require(ids.length == amounts.length, \"Length\");\n        for (uint256 i = 0; i < ids.length; i++) {\n            uint256 id = ids[i];\n            uint256 amt = amounts[i];\n            _balances[id][from] -= amt;\n            _balances[id][to] += amt;\n        }\n        emit TransferBatch(msg.sender, from, to, ids, amounts);\n    }\n\n    function mint(address to, uint256 id, uint256 amount, bytes calldata /* data */) external {\n        require(msg.sender == owner || minters[msg.sender], \"Not minter\");\n        require(to != address(0), \"Zero to\");\n        _balances[id][to] += amount;\n        emit TransferSingle(msg.sender, address(0), to, id, amount);\n    }\n\n    function burn(address from, uint256 id, uint256 amount) external {\n        require(msg.sender == owner || minters[msg.sender] || from == msg.sender, \"Not authorized\");\n        _balances[id][from] -= amount;\n        emit TransferSingle(msg.sender, from, address(0), id, amount);\n    }\n}\n";

export const RWA_SHARED_ERC1155 = {
  contractName: "RwaSharedErc1155",
  abi: RWA_SHARED_ERC1155_ABI,
  abiJson: JSON.stringify(RWA_SHARED_ERC1155_ABI),
  bytecode: RWA_SHARED_ERC1155_BYTECODE,
  mintFunctionName: "mint",
  soliditySource: RWA_SHARED_ERC1155_SOLIDITY_SOURCE,
  sourceFileName: "RwaSharedErc1155.sol"
};
